import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { EASE } from "./Reveal";

const BULLETS = [
  ["Cut", " onboarding time from 3 weeks to ", "8 days", " by rebuilding the training checklist."],
  ["Negotiated", " vendor renewals, saving ", "$18K", " a year across 4 contracts."],
  ["Trained", " ", "12", " new hires on the inventory system in their first month."],
];

export const ResumeCard = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [10, -10]), { stiffness: 120, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-12, 12]), { stiffness: 120, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <motion.div initial={{ opacity: 0, y: 60, rotateX: 25 }} animate={{ opacity: 1, y: 0, rotateX: 0 }}
      transition={{ duration: 1.4, ease: EASE, delay: 0.7 }} style={{ perspective: 1200 }}
      onMouseMove={onMove} onMouseLeave={reset} className="relative mx-auto max-w-md" data-testid="hero-resume-card">
      <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
        className="relative rounded-2xl bg-[var(--paper)] p-7 text-[var(--navy)] shadow-[0_40px_120px_-20px_rgba(45,226,208,0.35)] sm:p-9">
        <div className="flex items-baseline justify-between border-b border-[var(--navy)]/15 pb-4">
          <p className="font-serif-d text-2xl">Alex Rivera</p>
          <p className="font-mono-d text-[11px] uppercase tracking-widest text-slate-600">Sample</p>
        </div>
        <p className="font-mono-d mt-5 text-[11px] uppercase tracking-[0.2em] text-[var(--teal-deep)]">Experience</p>
        <p className="mt-2 text-sm font-semibold">Operations Coordinator</p>
        <ul className="mt-4 space-y-3.5 text-[15px] leading-snug">
          {BULLETS.map((b, i) => (
            <motion.li key={b[0]} initial={{ opacity: 0, x: -12 }} animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 1.3 + i * 0.18, duration: 0.8, ease: EASE }} className="flex gap-3">
              <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[var(--teal-deep)]" />
              <span><b className="font-semibold text-[var(--teal-deep)]">{b[0]}</b>{b[1]}
                <span className="bg-[var(--amber)]/35 px-0.5 font-semibold">{b[2]}</span>{b[3]}</span>
            </motion.li>
          ))}
        </ul>
        <div style={{ transform: "translateZ(60px)" }}
          className="absolute -top-5 right-2 rotate-3 rounded-lg bg-[var(--teal)] px-3 py-2 text-xs font-semibold text-[var(--ink)] shadow-xl sm:-right-8">
          "How many new hires?" → 12
        </div>
        <div style={{ transform: "translateZ(40px)" }} className="absolute -bottom-5 left-6 flex gap-2">
          {[".docx", ".pdf"].map((f) => (
            <span key={f} className="font-mono-d rounded-md border border-[var(--teal)]/40 bg-[var(--navy)] px-3 py-1.5 text-xs text-[var(--teal)]">resume{f}</span>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};
